import React, { Fragment } from 'react'
import { Heading } from '@myxplor/ui'

const Complete = ({ onClick }) => (
  <Fragment>
    <Heading>Export Complete</Heading>
    <p>Enrolments have been successfully exported</p>
    <a href="/export" className="btn-submit" onClick={onClick}>Export another</a>
  </Fragment>
)

export default Complete



// WEBPACK FOOTER //
// ./src/export/views/complete.jsx